export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10980.af980f61.jpg";